import React from 'react'
import { useTranslation } from 'react-i18next'

import { useProductReadContext } from '../context/ProductContext'

interface ProductContextSwitchModalProps {
  onConfirm(persistedClose?: boolean): void
  onCancel(): void
}

export const ProductContextSwitchModal: React.FC<ProductContextSwitchModalProps> = () => {
  const { t } = useTranslation()
  const { isDefaultCFDProductType } = useProductReadContext()

  return (
    <React.Fragment>
      <div className='is-flex is-flex-direction-column'>
        {t('Are you sure you want to switch', {
          to: isDefaultCFDProductType() ? 'Futures' : 'CFD',
        })}
      </div>
      <div className='my-5'>
        {t('Note: Your funds are not transferable between Futures and CFDs Client Areas')}
      </div>
    </React.Fragment>
  )
}
